import React from 'react';
import './Contact.css';
import textpic from '../../assets/text1.svg';
import { useRef } from 'react';
import emailjs from 'emailjs-com'
import { FaTelegramPlane } from 'react-icons/fa'
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

const Contact = () => {

  const { ref, inView } = useInView({
    threshold: 0.3, // Trigger animation when the component is at least 50% visible
    triggerOnce: false // Trigger animation every time the component comes into view
  });

  // Use `useAnimation` to trigger the animation
  const animation = useAnimation();

  // Define the animation
  const leftVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } }
  };
  const topVariants = {
    hidden: { opacity: 0, y: -30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };
  const imageVariants = {
    hidden: { opacity:0 ,scale: 0.8 },
    visible: { opacity: 1,scale: 1, transition: { duration: 1, ease: 'easeInOut' } },
  }

  

  // Use `useEffect` to trigger the animation when the component comes into view
  useEffect(() => {
    if (inView) {
      animation.start('visible');
    } else {
      animation.start('hidden');
    }
  }, [inView, animation]);










  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zi2w4hh', 'template_huqpll5', form.current, '4hLkLSHx1_1doC7hM')
    e.target.reset()


      .then((result) => {
          console.log(result.text);
      }, (error) => {
          console.log(error.text);
      });
  };






  return (
    <section id='Contact' ref={ref}>
      <motion.div  className='contact__div' variants={topVariants} 
          initial="hidden"
          animate={animation}>
      <h4 className='contact__h4'>Get in touch</h4>
      <h2 className='contact__heading'>Contact me</h2> 
      </motion.div >
      <motion.div className="container contact___container" variants={leftVariants} 
          initial="hidden"
          animate={animation}>
        <motion.div 
        variants={imageVariants} 
        initial="hidden"
        animate={animation}
         className="contact__pic">
          <img src={textpic} alt="" className='contact__svg'/>
        </motion.div >
        <div className="contact__form">
          <form action="" ref={form} onSubmit={sendEmail}>
            <input type="text" name='name' placeholder='Enter your name' required />
            <input type="email" name='email' placeholder='Your email' required />
            <textarea name="message"  rows="4" placeholder='Your Message' required></textarea>
            <button className='btn1primary5' type='submit'>Send <FaTelegramPlane className='telegram'/></button>
          </form>
        </div>
      </motion.div>
    </section>
  );
};

export default Contact;
